import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import HomeTeamSelector from './hometeam-selector';
import { ArenaConfig, Team } from '../types';
import { useStringsContext } from '../../../../contexts/strings';

const styles: SxStyle = {
  saveButton: {
    marginTop: '20px',
    marginRight: '20px',
  },
};

export default function ArenaForm({
  arenaConfig,
  teams,
  submitNewVenueConfig,
}: {
  arenaConfig: ArenaConfig;
  teams: Team[];
  submitNewVenueConfig: (config: ArenaConfig['venue']) => void;
}) {
  const { strings } = useStringsContext();
  // const { name, transticketInstanceId, homeTeamIds } = arenaConfig?.venue;
  const name = arenaConfig?.venue.name ?? '';
  const transticketInstanceId = arenaConfig?.venue.transticketInstanceId ?? '';
  const homeTeamIds = arenaConfig?.venue.homeTeamIds ?? [];
  const [transticketInstanceIdValue, setTransticketInstanceIdValue] =
    useState(transticketInstanceId);
  const [arenaNameValue, setArenaNameValue] = useState(name);
  const [selectedTeamsArr, setSelectedTeams] = useState<string[]>(
    teams
      .filter((team) => homeTeamIds.includes(team.everySportId?.toString()))
      .map((t) => t?.shorterName)
  );

  const selectedTeams = teams
    .filter((team) => homeTeamIds.includes(team.everySportId?.toString()))
    .map((t) => t?.shorterName);

  const selectableTeams = teams
    .filter((team) => !homeTeamIds.includes(team.everySportId?.toString()))
    .map((t) => t?.shorterName);

  const onChangeTransticketInstanceId = (e: any) => {
    setTransticketInstanceIdValue(e.target.value);
  };

  const onChangeArenaName = (e: any) => {
    setArenaNameValue(e.target.value);
  };

  const resetForm = () => {
    const defSelectedTeams = teams
      .filter((team) => homeTeamIds.includes(team?.everySportId?.toString()))
      .map((t) => t?.shorterName);
    setArenaNameValue(name);
    setTransticketInstanceIdValue(transticketInstanceId);
    setSelectedTeams(defSelectedTeams);
  };

  const saveConfiguration = () => {
    const selectedTeamsObject = teams.filter((t) => selectedTeamsArr.includes(t.shorterName));
    const teamNames = selectedTeamsObject.map((t) => t.shorterName);
    const teamIds = selectedTeamsObject.map((t) => t.everySportId.toString());

    const configuration = {
      name: arenaNameValue,
      transticketInstanceId: transticketInstanceIdValue,
      homeTeamIds: teamIds,
      homeTeamNames: teamNames,
    };

    submitNewVenueConfig(configuration);
  };

  const showSaveAndResetButton =
    name !== arenaNameValue ||
    transticketInstanceIdValue !== transticketInstanceId ||
    selectedTeamsArr.length !== selectedTeams.length;

  return (
    <>
      <TextField
        id="outlined-full-width"
        label={strings.wifi.arena}
        value={arenaNameValue}
        fullWidth
        margin="normal"
        variant="outlined"
        onChange={onChangeArenaName}
      />
      <TextField
        id="outlined-full-width"
        label={strings.wifi.transticketInstanceId}
        placeholder={transticketInstanceId}
        fullWidth
        margin="normal"
        value={transticketInstanceIdValue}
        variant="outlined"
        onChange={onChangeTransticketInstanceId}
      />
      {selectedTeams && selectableTeams && (
        <HomeTeamSelector
          selectableTeams={selectableTeams.filter((t) => t !== undefined)}
          selectedTeams={selectedTeamsArr}
          setSelectedTeams={setSelectedTeams}
        />
      )}
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={() => resetForm()}
        >
          Cancel
        </Button>
      )}
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={saveConfiguration}
        >
          Save
        </Button>
      )}
    </>
  );
}
